import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { AppState } from '../../../reducers';
import { CrudService, SnackbarService, RxjsService, SignalrConnectionService, UserService, MomentService } from '../../../shared/services';
import { ModulesBasedApiSuffix } from '../../../shared/utils/enums.utils';
import { IApplicationResponse } from '../../../shared/utils/interfaces.utils';
import { Store, select } from '@ngrx/store';
import { MessageService } from 'primeng/api';
import { ScrollPanel } from 'primeng/scrollpanel';
import { forkJoin, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { loggedInUserData } from '../../../modules/others/auth.selectors';
import { UserLogin } from '../../../modules/others/models/others-module-models';
import { TechnicalMgntModuleApiSuffixModels } from '../../../modules/technical-management/shared/enum.ts';
import { ChatRoomModuleApiSuffixModels } from '../../../modules/chat-room/shared/utils/chat-room-module.enum';
import { ChatRoomModel } from '../../../modules/chat-room/models/chat-room.model';
import { Menu } from 'primeng/menu';
import { FILE_ACCEPTS, STANDARD_FILE_FORMATS } from '../../../shared/utils/variables.utils';
import { isValidFilename, prepareGetRequestHttpParams, prepareRequiredHttpParams, setRequiredValidator } from '../../../shared/utils/functions.utils';
import { ChatEvents, ChatInvoke } from '@app/shared';

@Component({
    selector: 'app-quick-chat',
    templateUrl: './quick-chat.component.html',
    styleUrls: ['./quick-chat.component.scss'],
    providers: [MessageService]
})
export class QuickChatComponent implements OnInit {
    totalFileSize = 0;
    loggedUser: UserLogin | any;
    userList = [];
    userListOriginalData = [];
    searchedUserList = [];
    selectedEntity: any = {};
    messages = [];
    encodedToken: string = 'sadasdasda';
    chatRoomForm: FormGroup;
    myConnectionInfo: any;
    showUsersList = true;
    isNewMenuClicked = false;
    isProceedForNewMenuClicked = false;
    newClickedMenuName = '';
    selectedEntityForGroupOrBroadcast = [];
    showParticipantInfo = false;
    participantList = [];
    removedParticipantsList = [];
    groupOrBroadcastSelectedMenu = '';
    selectedFiles = new Array();
    sound: any;
    selectedTab = 'all';
    @ViewChild('file', { static: false }) uploadFile: ElementRef;
    @ViewChild('sendMsg', { static: false }) sendMsg: ElementRef<HTMLTextAreaElement>;
    @ViewChild('chatScrollBar', { static: false }) chatScrollBar: ScrollPanel; //NgScrollbar;
    scrollData: any;
    maximumChats = 100;
    showSpinnerOnScroll = false;
    callOnScroll = false;
    _FileSize: any;
    showProfileInfo = false;
    listSubscription: any;
    chatEventsSubscription: any;
    uploadformdata: any;
    //receipt starts
    readByReceiptList: any = [];
    unreadByReceiptList: any = [];
    receiptList: any = [];
    showReceiptInfo: boolean;
    selectedReceiptIndex = 0;
    receiptTabList: any = [
        {
            caption: 'Read by',
        },
        {
            caption: 'Unread',
        }
    ];
    quickItems = [{ label: 'New Chat', command: () => this.onNewMenuClick('Chat') },
    { label: 'New group', command: () => this.onNewMenuClick('Group') },
    { label: 'New Broadcast', command: () => this.onNewMenuClick('Broadcast') },];
    quickChatItems = [];
    quickReceiptItems = [{ label: 'Read Receipt', class: 'status-label-blue', command: (e, msg) => this.onReadReceipt(msg) }];
    @ViewChild('menu1', { static: false }) quickMenu1: Menu;
    @ViewChild('menu2', { static: false }) quickChatMenu1: Menu;
    //receipt ends
    accept: any = FILE_ACCEPTS;
    fileFormats: any = STANDARD_FILE_FORMATS;

    constructor(private crudService: CrudService,
        private store: Store<AppState>, private snackbarService: SnackbarService,
        private rxjsService: RxjsService, private userService: UserService,
        private formBuilder: FormBuilder,
        private messageService: MessageService, private signalrConnectionService: SignalrConnectionService,
        private momentService: MomentService) {
        this.store.pipe(select(loggedInUserData)).subscribe((userData: UserLogin) => {
            if (!userData) return;
            this.loggedUser = userData;
        });
        this.rxjsService.setDialogOpenProperty(true);
        const chatUserDetails = this.userService.chatUserDetails;
        if (chatUserDetails) {
            this.myConnectionInfo = chatUserDetails;
        }
    }

    ngOnInit(): void {
        this.createChatRoomForm();
        this.onLoadValue();
        this.sound = document.getElementById("audio");
    }

    onReloadUserList() {
        this.rxjsService.setGlobalLoaderProperty(true);
        this.crudService.get(
            ModulesBasedApiSuffix.COMMON_API,
            ChatRoomModuleApiSuffixModels.GET_ALL_USERS,
            this.loggedUser.userId
        ).subscribe((res: IApplicationResponse) => {
            if (res?.isSuccess && res?.statusCode == 200) {
                this.userListOriginalData = res['resources'];
                this.userList = this.userListOriginalData;
                this.searchedUserList = [...this.userList];
                this.filterUserList(this.newClickedMenuName.toLocaleLowerCase());
            }
            this.rxjsService.setGlobalLoaderProperty(false);
        })
    }

    onLoadValue() {
        this.rxjsService.setPopupLoaderProperty(true);
        let api = [this.getonChatFileSizeConfigurationDetailsById(), this.crudService.get(
            ModulesBasedApiSuffix.COMMON_API,
            ChatRoomModuleApiSuffixModels.GET_ALL_USERS,
            this.loggedUser.userId
        )]
        this.listSubscription = forkJoin(api).subscribe((Response: IApplicationResponse[]) => {
            Response?.forEach((res: IApplicationResponse, ix: number) => {
                if (res?.isSuccess && res?.statusCode == 200) {
                    switch (ix) {
                        case 0:
                            this._FileSize = Number(res.resources?.chatFileSizeName);
                            break;
                        case 1:
                            this.userListOriginalData = res['resources'];
                            this.userList = this.userListOriginalData;
                            this.searchedUserList = [...this.userList];
                            this.onLoadChatEvents();
                            break;
                    }
                }
            })
            this.rxjsService.setPopupLoaderProperty(false);
        })
    }

    onLoadChatEvents() {
        this.chatEventsSubscription = this.signalrConnectionService.getChatObserveEvent().subscribe((res: any) => {
            const eventName = res?.event;
            if (res && eventName == ChatEvents.NEW_MESSAGE) {
                console.log(ChatEvents.NEW_MESSAGE);
                this.onNewMessageReceived(res?.result);
            } else if (res && eventName == ChatEvents.GET_ONLINE_USERS) {
                console.log(ChatEvents.GET_ONLINE_USERS);
                this.onOnlineUsers(res?.result);
            } else if (res && eventName == ChatEvents.USER_DETAILS) {
                console.log(ChatEvents.USER_DETAILS);
                this.userService.chatUserDetails = res?.result;
                this.onUserDetails(res?.result);
            } else if (res && eventName == ChatEvents.ADDED_IN_GROUP) {
                console.log(ChatEvents.ADDED_IN_GROUP);
                this.onAddedInGroup(res?.result);
            } else if (res && eventName == ChatEvents.BROADCAST_CREATED) {
                console.log(ChatEvents.BROADCAST_CREATED);
                this.onBroadcastCreated(res?.result);
            } else if (res && eventName == ChatEvents.DOCUMENT_RECEIVED) {
                console.log(ChatEvents.DOCUMENT_RECEIVED);
                this.onDocumentReceived(res?.result);
            } else if (res && eventName == ChatEvents.REMOVED_FROM_GROUP) {
                console.log(ChatEvents.REMOVED_FROM_GROUP);
                this.onRemovedFromGroup(res?.result);
            } else if (res && eventName == ChatEvents.ON_DISCONNECT) {
                console.log(ChatEvents.ON_DISCONNECT);
                this.onDisconnect(res?.result);
            }
        })
    }

    createChatRoomForm(chatRoomModel?: ChatRoomModel) {
        let chatModel = new ChatRoomModel(chatRoomModel);
        this.chatRoomForm = this.formBuilder.group({});
        Object.keys(chatModel).forEach((key) => {
            if (typeof chatModel[key] !== 'object') {
                this.chatRoomForm.addControl(key, new FormControl(chatModel[key]));
            }
        });
        this.chatRoomForm = setRequiredValidator(this.chatRoomForm, ['groupName']);
        this.chatRoomForm.get('sendMessage').disable();
        this.onValueChanges();
    }

    onValueChanges() {
        this.chatRoomForm.get('searchEntity').valueChanges.pipe(debounceTime(800), distinctUntilChanged())
            .subscribe((response: any) => {
                if (response != null) {
                    this.hideAllQuickMenu();
                    this.userList = this.searchedUserList?.filter(userData => userData['name'].
                        toLowerCase().indexOf(response.toLowerCase()) > -1);
                } else {
                    this.userList = [];
                }
            });
    }

    onShowProfileInfo() {
        this.showProfileInfo = true;
    }

    getParticipantDetails() {
        this.groupOrBroadcastSelectedMenu = '';
        if (this.selectedEntity['isGroup']) {
            this.rxjsService.setPopupLoaderProperty(true);
            this.participantList = [];
            this.crudService.get(
                ModulesBasedApiSuffix.COMMON_API,
                ChatRoomModuleApiSuffixModels.GET_USERS_INFO,
                undefined,
                false,
                prepareRequiredHttpParams({ GroupId: this.selectedEntity['id'] })
            ).subscribe((usersData: IApplicationResponse) => {
                if (usersData.isSuccess && usersData.statusCode === 200) {
                    this.participantList = usersData['resources']
                    this.showParticipantInfo = true;
                }
                this.rxjsService.setPopupLoaderProperty(false);
            });
        } else {

        }
    }

    toggleProfileInfo() {
        this.showProfileInfo = false; //!this.showParticipantInfo;
    }

    toggleParticipantInfo() {
        this.showParticipantInfo = false; //!this.showParticipantInfo;
    }

    toggleReceiptInfo() {
        this.showReceiptInfo = false;
    }

    onClickEntityDetailsMenu(e) {
        this.quickMenu1?.hide();
        if (this.selectedEntity['isGroup']) {
            this.quickChatItems = [{ label: 'Profile Info', command: () => this.onShowProfileInfo() },
            { label: 'View Participants', command: () => this.getParticipantDetails() },
            { label: 'Add Participant', command: () => this.addParticipantToGroup() },
            { label: 'Remove Participant', command: () => this.removeParticipantFromGroup() },
            { label: 'Delete Chat', command: () => this.onDeleteMessages() }]
        } else {
            this.quickChatItems = [{ label: 'Profile Info', command: () => this.onShowProfileInfo() },
            { label: 'Delete Chat', command: () => this.onDeleteMessages() }];
        }
        this.quickChatMenu1?.toggle(e);
        this.showParticipantInfo = false;
    }

    removeParticipantFromGroup() {
        this.getParticipantDetails();
        this.groupOrBroadcastSelectedMenu = 'remove';
    }

    addParticipantToGroup() {
        this.getParticipantList();
        this.groupOrBroadcastSelectedMenu = 'add';
    }

    getParticipantList() { // Get available user list to add it in group
        if (this.selectedEntity['isGroup']) {
            this.participantList = [];
            this.rxjsService.setPopupLoaderProperty(true);
            this.crudService.get(
                ModulesBasedApiSuffix.COMMON_API,
                ChatRoomModuleApiSuffixModels.GET_USERS_LIST,
                undefined,
                false,
                prepareRequiredHttpParams({ UserId: this.loggedUser.userId, GroupId: this.selectedEntity['id'] })
            ).subscribe((usersData: IApplicationResponse) => {
                if (usersData.isSuccess && usersData.statusCode === 200) {
                    this.participantList = usersData['resources']
                    this.showParticipantInfo = true;
                }
                this.rxjsService.setPopupLoaderProperty(false);
            });
        } else {

        }
    }

    onClickParticipantDetails(participantData) {
        if (this.groupOrBroadcastSelectedMenu == 'add' || this.groupOrBroadcastSelectedMenu == 'remove') {
            let selectedUserIndex = this.removedParticipantsList.findIndex(selectedUser => selectedUser['Id'] == participantData['id']);
            if (selectedUserIndex >= 0) {
                this.removedParticipantsList.splice(selectedUserIndex, 1);
                participantData['isSelected'] = false;
            } else {
                this.removedParticipantsList.push({ Id: participantData['id'], ConnectionId: participantData['connectionId'] });
                participantData['isSelected'] = true;
            }
        }
    }

    removeAddParticipants() {
        if (this.myConnectionInfo != undefined && this.myConnectionInfo['Id'] != undefined) {
            if (this.groupOrBroadcastSelectedMenu == 'remove') {
                this.signalrConnectionService.hubConnectionForChatAPI.invoke(ChatInvoke.LEAVE_GROUP, this.myConnectionInfo['Id'], this.selectedEntity['id'], JSON.stringify(this.removedParticipantsList), this.selectedEntity['name']);
                this.participantList = this.participantList.filter(element => !(this.removedParticipantsList.map(e => e.Id).indexOf(element['id']) > -1));
                this.removedParticipantsList = [];
            } else if (this.groupOrBroadcastSelectedMenu == 'add') {
                this.signalrConnectionService.hubConnectionForChatAPI.invoke(ChatInvoke.JOIN_GROUP, this.myConnectionInfo['Id'], this.selectedEntity['id'], JSON.stringify(this.removedParticipantsList), this.selectedEntity['name']);
                this.removedParticipantsList = [];
            }
        } else {
            console.log(`Connection issue on ${this.groupOrBroadcastSelectedMenu} participents`);
        }
    }

    onOnlineUsers(loggedInUsers) {
        if (this.userListOriginalData != undefined) {
            for (var i = 0; i < this.userListOriginalData?.length; i++) {
                for (var j = 0; j < loggedInUsers?.length; j++) {
                    if (this.userListOriginalData[i]?.id?.toLowerCase() == loggedInUsers[j]?.Id?.toLowerCase()) {
                        this.userListOriginalData[i].connectionId = loggedInUsers[j]?.ConnectionId;
                        this.userListOriginalData[i].status = loggedInUsers[j]?.Status;
                    }
                    if (this.selectedEntity?.id?.toLowerCase() == loggedInUsers[j].Id.toLowerCase()) {
                        this.selectedEntity.connectionId = loggedInUsers[j].ConnectionId;
                        this.selectedEntity.status = loggedInUsers[j].Status;
                    }
                }
            }
        }
        if (this.selectedTab =='all') {
            this.userList = this.userListOriginalData;  // To maintain complete list of user intact
            this.searchedUserList = [...this.userList]; // searching purpose
            this.filterUserList(this.selectedTab);
        }
    }

    getOnlineUser(userData) {
        return userData?.status?.toLowerCase() == 'online';
    }

    onNewMessageReceived(receivedMessage) {
        if (Object.keys(this.selectedEntity).length > 0) {
           // let sendMessageTimeStamp = new Date();
            // let strTime = sendMessageTimeStamp.toLocaleString("en-US", {
            //     timeZone: 'Africa/Cairo'
            // });
           // const dateTimeUtc = this.momentService.toMoment(strTime).format("h:mm A");
            if (receivedMessage['IsGroup'] && !receivedMessage['IsBroadCast']) { // Only for Group
                if (this.selectedEntity['id'].toLowerCase() == receivedMessage.Id.toLowerCase()) {
                    this.messages.push({
                        connectionId: receivedMessage.NewMessage.ConnectionId,
                        receiver: receivedMessage.NewMessage.Receiver,
                        sender: receivedMessage.NewMessage.Sender,
                        text: receivedMessage.NewMessage.Text,
                        toConnectionId: receivedMessage.NewMessage.ToConnectionId,
                        time: receivedMessage.NewMessage.Time,
                        isGroup: receivedMessage.IsGroup,
                        fromUserId: receivedMessage.NewMessage.FromUserId,
                        touserId: receivedMessage.NewMessage.ToUserId,
                        fileName: receivedMessage.NewMessage.FileName,
                        messageId: receivedMessage.NewMessage.MessageId,
                        isFile: false
                    });
                } else {
                    for (var i = 0; i < this.userListOriginalData.length; i++) {
                        if (this.userListOriginalData[i].id.toLowerCase() == receivedMessage.Id.toLowerCase()) {
                            this.userListOriginalData[i].messageCount = parseInt(this.userListOriginalData[i].messageCount) + 1;
                            this.userListOriginalData[i].date = new Date();
                            break;
                        }
                    }
                }
            } else if (receivedMessage['IsGroup'] && receivedMessage['IsBroadCast']) { // only broadcast
                if (receivedMessage.Id.toLowerCase() == this.selectedEntity['id'].toLowerCase() || this.selectedEntity['id'].toLowerCase() == receivedMessage.NewMessage.FromUserId.toLowerCase()) {// If logged in user and for all recipients
                    this.messages.push({
                        connectionId: receivedMessage.NewMessage.ConnectionId,
                        receiver: receivedMessage.NewMessage.Receiver,
                        sender: receivedMessage.NewMessage.Sender,
                        text: receivedMessage.NewMessage.Text,
                        toConnectionId: receivedMessage.NewMessage.ToConnectionId,
                        time: receivedMessage.NewMessage.Time,
                        isGroup: receivedMessage.IsGroup,
                        fromUserId: receivedMessage.NewMessage.FromUserId,
                        touserId: receivedMessage.NewMessage.ToUserId,
                        fileName: receivedMessage.NewMessage.FileName,
                        messageId: receivedMessage.NewMessage.MessageId,
                        isFile: false
                    });
                } else {
                    for (var i = 0; i < this.userListOriginalData.length; i++) {
                        if (this.userListOriginalData[i].id.toLowerCase() == receivedMessage.NewMessage.FromUserId.toLowerCase()) {
                            this.userListOriginalData[i].messageCount = parseInt(this.userListOriginalData[i].messageCount) + 1;
                            this.userListOriginalData[i].date = new Date();
                            break;
                        }
                    }
                }
            } else { // single chat user
                if (this.selectedEntity['id'].toLowerCase() == receivedMessage.NewMessage.FromUserId.toLowerCase()) {
                    this.messages.push({
                        connectionId: receivedMessage.NewMessage.ConnectionId,
                        receiver: receivedMessage.NewMessage.Receiver,
                        sender: receivedMessage.NewMessage.Sender,
                        text: receivedMessage.NewMessage.Text,
                        toConnectionId: receivedMessage.NewMessage.ToConnectionId,
                        time: receivedMessage.NewMessage.Time,
                        isGroup: receivedMessage.IsGroup,
                        fromUserId: receivedMessage.NewMessage.FromUserId,
                        touserId: receivedMessage.NewMessage.ToUserId,
                        fileName: receivedMessage.NewMessage.FileName,
                        messageId: receivedMessage.NewMessage.MessageId,
                        isFile: false
                    });
                } else {
                    for (var i = 0; i < this.userListOriginalData.length; i++) {
                        if (this.userListOriginalData[i].id.toLowerCase() == receivedMessage.NewMessage.FromUserId.toLowerCase()) {
                            this.userListOriginalData[i].messageCount = parseInt(this.userListOriginalData[i].messageCount) + 1;
                            this.userListOriginalData[i].date = new Date();
                            break;
                        }
                    }
                }

            }
            this.scrollOnSendReceive();
        } else {
            for (var i = 0; i < this.userListOriginalData.length; i++) {
                if (this.userListOriginalData[i].id.toLowerCase() == receivedMessage.NewMessage.FromUserId.toLowerCase()) {
                    this.userListOriginalData[i].messageCount = parseInt(this.userListOriginalData[i].messageCount) + 1;
                    this.userListOriginalData[i].date = new Date();
                    break;
                }
            }
        }

        this.sound.play();
        this.userList = this.userList.sort(function (user2, user1) {
            return new Date(user1.date).getTime() - new Date(user2.date).getTime();
        });
        this.searchedUserList = this.userList;
        this.messageService.add({ severity: 'info', summary: receivedMessage.NewMessage.Sender, detail: receivedMessage.NewMessage.Text });
    }

    onDeleteMessages() {
        if (Object.keys(this.selectedEntity)?.length == 0) {
            this.snackbarService.openSnackbar("Please select the chat");
        }
        let deleteData = {
            FromUserId: this.loggedUser.userId,
            ToUserId: this.selectedEntity['id']?.toLowerCase() 
        };
        if (this.selectedEntity['isGroup']) {
            deleteData['IsGroup'] = this.selectedEntity['isGroup']
        }
        this.showSpinnerOnScroll = true;
        this.rxjsService.setPopupLoaderProperty(true);
        this.crudService.delete(
            ModulesBasedApiSuffix.COMMON_API,
            ChatRoomModuleApiSuffixModels.DELETE_CHAT,
            '',
            prepareRequiredHttpParams(deleteData)
        ).subscribe((response: IApplicationResponse) => {
            if (response.isSuccess && response.statusCode === 200) {
                this.messages = [];
            }
            this.showSpinnerOnScroll = false;
            this.rxjsService.setPopupLoaderProperty(false);
        });

    }

    onUserDetails(userDetails) {
        if (userDetails) {
            this.myConnectionInfo = userDetails ? userDetails : {};
        }
    }

    onDisconnect(disconnectedData) {
        this.userListOriginalData.forEach(userData => {
            if (userData['connectionId'] == disconnectedData['ConnectionId'] && disconnectedData['Id'] == userData['id'])
                userData['status'] = disconnectedData['Status'];
        });
    }

    onRemovedFromGroup(removedParticipantsData) {
        this.userListOriginalData = this.userListOriginalData.filter(element => (element['id'] != removedParticipantsData['Id']));
        if (this.selectedEntity['id']?.toLowerCase()  == removedParticipantsData['Id']?.toLowerCase() ) {
            this.selectedEntity = {};
            this.messages = [];
        }
        this.searchedUserList = this.userListOriginalData;
        // this.userList = this.userListOriginalData;
        this.filterUserList(removedParticipantsData['IsBroadCast'] ? 'broadcast' : 'group');
    }

    onDocumentReceived(documentReceivedData) {
        // if (Object.keys(this.selectedEntity).length > 0 && this.selectedEntity['id'].toLowerCase() == documentReceivedData.NewMessage.FromUserId.toLowerCase()) {
        //     this.messages.push({
        //         connectionId: documentReceivedData.NewMessage.ConnectionId,
        //         receiver: documentReceivedData.NewMessage.Receiver,
        //         sender: documentReceivedData.NewMessage.Sender,
        //         text: documentReceivedData.NewMessage.Text,
        //         toConnectionId: documentReceivedData.NewMessage.ToConnectionId,
        //         time: documentReceivedData.NewMessage.Time,
        //         isGroup: documentReceivedData.IsGroup,
        //         fromUserId: documentReceivedData.NewMessage.FromUserId,
        //         touserId: documentReceivedData.NewMessage.ToUserId,
        //         fileName: documentReceivedData.NewMessage.FileName,
        //         isFile: true
        //     });
        // } else {
        //     for (var i = 0; i < this.userListOriginalData.length; i++) {
        //         if (this.userListOriginalData[i].id.toLowerCase() == documentReceivedData.NewMessage.FromUserId.toLowerCase()) {
        //             this.userListOriginalData[i].messageCount = parseInt(this.userListOriginalData[i].messageCount) + 1;
        //             break;
        //         }
        //     }
        // }
        // this.sound.play();
        // this.messageService.add({severity:'info', summary: documentReceivedData.NewMessage.Sender, detail: 'File'});


        if (Object.keys(this.selectedEntity).length > 0) {
            //let sendMessageTimeStamp = new Date();
            // let strTime = sendMessageTimeStamp.toLocaleString("en-US", {
            //     timeZone: 'Africa/Cairo'
            // });
            // const dateTimeUtc = this.momentService.toMoment(strTime).format("h:mm A");
            if (documentReceivedData['IsGroup'] && !documentReceivedData['IsBroadCast']) { // Only for Group
                if (this.selectedEntity['id'].toLowerCase() == documentReceivedData.Id.toLowerCase()) {
                    this.messages.push({
                        connectionId: documentReceivedData.NewMessage.ConnectionId,
                        receiver: documentReceivedData.NewMessage.Receiver,
                        sender: documentReceivedData.NewMessage.Sender,
                        text: documentReceivedData.NewMessage.Text,
                        toConnectionId: documentReceivedData.NewMessage.ToConnectionId,
                        time: documentReceivedData.NewMessage.Time,
                        isGroup: documentReceivedData.IsGroup,
                        fromUserId: documentReceivedData.NewMessage.FromUserId,
                        touserId: documentReceivedData.NewMessage.ToUserId,
                        fileName: documentReceivedData.NewMessage.FileName,
                        messageId: documentReceivedData.NewMessage.MessageId,
                        isFile: true
                    });
                } else {
                    for (var i = 0; i < this.userListOriginalData.length; i++) {
                        if (this.userListOriginalData[i].id.toLowerCase() == documentReceivedData.Id.toLowerCase()) {
                            this.userListOriginalData[i].messageCount = parseInt(this.userListOriginalData[i].messageCount) + 1;
                            this.userListOriginalData[i].date = new Date();
                            break;
                        }
                    }
                }
            } else if (documentReceivedData['IsGroup'] && documentReceivedData['IsBroadCast']) { // only broadcast
                if (documentReceivedData.Id.toLowerCase() == this.selectedEntity['id'].toLowerCase() || this.selectedEntity['id'].toLowerCase() == documentReceivedData.NewMessage.FromUserId.toLowerCase()) {// If logged in user and for all recipients
                    this.messages.push({
                        connectionId: documentReceivedData.NewMessage.ConnectionId,
                        receiver: documentReceivedData.NewMessage.Receiver,
                        sender: documentReceivedData.NewMessage.Sender,
                        text: documentReceivedData.NewMessage.Text,
                        toConnectionId: documentReceivedData.NewMessage.ToConnectionId,
                        time: documentReceivedData.NewMessage.Time,
                        isGroup: documentReceivedData.IsGroup,
                        fromUserId: documentReceivedData.NewMessage.FromUserId,
                        touserId: documentReceivedData.NewMessage.ToUserId,
                        fileName: documentReceivedData.NewMessage.FileName,
                        messageId: documentReceivedData.NewMessage.MessageId,
                        isFile: true
                    });
                } else {
                    for (var i = 0; i < this.userListOriginalData.length; i++) {
                        if (this.userListOriginalData[i].id.toLowerCase() == documentReceivedData.NewMessage.FromUserId.toLowerCase()) {
                            this.userListOriginalData[i].messageCount = parseInt(this.userListOriginalData[i].messageCount) + 1;
                            this.userListOriginalData[i].date = new Date();
                            break;
                        }
                    }
                }
            } else { // single chat user
                if (this.selectedEntity['id'].toLowerCase() == documentReceivedData.NewMessage.FromUserId.toLowerCase()) {
                    this.messages.push({
                        connectionId: documentReceivedData.NewMessage.ConnectionId,
                        receiver: documentReceivedData.NewMessage.Receiver,
                        sender: documentReceivedData.NewMessage.Sender,
                        text: documentReceivedData.NewMessage.Text,
                        toConnectionId: documentReceivedData.NewMessage.ToConnectionId,
                        time: documentReceivedData.NewMessage.Time,
                        isGroup: documentReceivedData.IsGroup,
                        fromUserId: documentReceivedData.NewMessage.FromUserId,
                        touserId: documentReceivedData.NewMessage.ToUserId,
                        fileName: documentReceivedData.NewMessage.FileName,
                        messageId: documentReceivedData.NewMessage.MessageId,
                        isFile: true
                    });
                } else {
                    for (var i = 0; i < this.userListOriginalData.length; i++) {
                        if (this.userListOriginalData[i].id.toLowerCase() == documentReceivedData.NewMessage.FromUserId.toLowerCase()) {
                            this.userListOriginalData[i].messageCount = parseInt(this.userListOriginalData[i].messageCount) + 1;
                            this.userListOriginalData[i].date = new Date();
                            break;
                        }
                    }
                }

            }
            this.scrollOnSendReceive();
        } else {
            for (var i = 0; i < this.userListOriginalData.length; i++) {
                if (this.userListOriginalData[i].id.toLowerCase() == documentReceivedData.NewMessage.FromUserId.toLowerCase()) {
                    this.userListOriginalData[i].messageCount = parseInt(this.userListOriginalData[i].messageCount) + 1;
                    this.userListOriginalData[i].date = new Date();
                    break;
                }
            }
        }

        this.sound.play();
        this.userList = this.userList.sort(function (user2, user1) {
            return new Date(user1.date).getTime() - new Date(user2.date).getTime();
        });
        this.searchedUserList = this.userList;
        this.messageService.add({ severity: 'info', summary: documentReceivedData.NewMessage.Sender, detail: documentReceivedData.NewMessage.FileName });
        setTimeout(() => {
            this.messageService.clear();
        }, 10000);
    }

    onAddedInGroup(groupDetails) {
        groupDetails['id'] = groupDetails['Id'];
        groupDetails['name'] = groupDetails['Name'];
        groupDetails['isBroadCast'] = groupDetails['IsBroadCast'];
        groupDetails['isGroup'] = groupDetails['IsGroup'];
        delete groupDetails['Id'];
        delete groupDetails['Name'];
        delete groupDetails['IsBroadCast'];
        delete groupDetails['IsGroup'];
        this.userListOriginalData.push(groupDetails);
        this.searchedUserList.push(groupDetails);
        this.userList.push(groupDetails);

        // To get details of group messages and show on chat window for user who has created group not for other users
        // if(groupDetails['']) {
        this.selectedEntity = groupDetails;
        this.resetUserList('isSelected');
        // }
    }

    onBroadcastCreated(broadastDetails) {
        broadastDetails['id'] = broadastDetails['Id'];
        broadastDetails['name'] = broadastDetails['Name'];
        broadastDetails['isBroadCast'] = broadastDetails['IsBroadCast'];
        broadastDetails['isGroup'] = broadastDetails['IsGroup'];
        delete broadastDetails['Id'];
        delete broadastDetails['Name'];
        delete broadastDetails['IsBroadCast'];
        delete broadastDetails['IsGroup'];
        this.userListOriginalData.push(broadastDetails);
        this.searchedUserList.push(broadastDetails);
        this.userList.push(broadastDetails);
        this.resetUserList('isSelected');
        // To get details of group messages and show on chat window for user who has created group not for other users
        // if(groupDetails['']) {
        this.selectedEntity = broadastDetails;
        // }
    }

    filterUserList(type: string) {
        this.hideAllQuickMenu();
        if (type == 'all') {
            this.userList = this.userListOriginalData;
        } else if (type == 'chat') {
            this.userList = this.userListOriginalData.filter(userData => !userData.isGroup);
        } else if (type == 'group') {
            this.userList = this.userListOriginalData.filter(userData => userData.isGroup && !userData.isBroadCast);

        } else if (type == 'broadcast') {
            this.userList = this.userListOriginalData.filter(userData => userData.isBroadCast);
        }
        this.searchedUserList = [...this.userList];
        this.selectedTab = type;
    }

    onNewMenuClick(type) {
        this.isNewMenuClicked = true;
        this.isProceedForNewMenuClicked = false;
        this.newClickedMenuName = type;
        this.selectedEntityForGroupOrBroadcast = [];
        this.resetUserList('isSelected');
        this.filterUserList('chat');
    }

    onCancelNewMenuSelection() {
        if (this.isProceedForNewMenuClicked) {
            this.showUsersList = true;
            this.isProceedForNewMenuClicked = false;
        } else {
            this.onCancelGroupBoardCast(this.newClickedMenuName);
        }
    }

    onCancelGroupBoardCast(type) {
        this.isNewMenuClicked = false;
        this.isProceedForNewMenuClicked = false;
        this.newClickedMenuName = type;
        this.selectedEntityForGroupOrBroadcast = [];
        this.resetUserList('isSelected');
        this.filterUserList(type?.toLowerCase());
    }

    showListView() {
        // this.resetUserList('isSelected');
        // this.isNewMenuClicked = false;
        // this.newClickedMenuName = '';
        // this.selectedEntityForGroupOrBroadcast = [];
        this.onCancelNewMenuSelection();
    }



    validateGroupExists() {
        let group = [];
        this.userList?.forEach((el: any) => {
            if (el?.isGroup && el?.name == this.chatRoomForm.controls['groupName']?.value?.trim() && this.newClickedMenuName?.toLowerCase() == 'group') {
                group.push(true);
            } else if (el?.isBroadCast && el?.name == this.chatRoomForm.controls['groupName']?.value?.trim() && this.newClickedMenuName?.toLowerCase() == 'broadcast') {
                group.push(true);
            }
        })
        return group?.length;
    }

    onProceedNewMenuSelection() {
        if (this.selectedEntityForGroupOrBroadcast.length > 0) {
            this.isProceedForNewMenuClicked = !this.isProceedForNewMenuClicked;
            if (this.isProceedForNewMenuClicked) { // when clicked on Proceed
                this.showUsersList = false;
            }
        }
    }

    onCreateGroupName() {
        if (this.selectedEntityForGroupOrBroadcast.length > 0) {
            if (this.chatRoomForm.controls['groupName'].invalid) {
                this.isProceedForNewMenuClicked = true;
                this.chatRoomForm.controls['groupName'].markAllAsTouched()
                return;
            }
            this.onValidateGroupExistAPI();
        }
    }

    onValidateGroupExistAPI() {
        const isBroadCast = this.newClickedMenuName?.toLowerCase() == 'broadcast' ? true : false;
        this.rxjsService.setPopupLoaderProperty(true);
        this.crudService.get(ModulesBasedApiSuffix.SHARED, TechnicalMgntModuleApiSuffixModels.CHAT_GROUP_VALIDATE,
            null, false, prepareRequiredHttpParams({
                groupName: this.chatRoomForm.controls['groupName']?.value?.trim(),
                isBroadCast: isBroadCast, userId: this.loggedUser?.userId
            }))
            .subscribe((res: IApplicationResponse) => {
                if (res?.isSuccess && res?.statusCode == 200) {
                    this.onCreateGrp();
                } else {
                    this.isProceedForNewMenuClicked = true;
                }
                this.rxjsService.setPopupLoaderProperty(false);
            })
    }

    onCreateGrp() {
        if (this.myConnectionInfo != undefined && this.myConnectionInfo['Id'] != undefined && this.myConnectionInfo['ConnectionId'] != undefined) {
            this.isProceedForNewMenuClicked = false;
            this.selectedEntityForGroupOrBroadcast.push({ Id: this.myConnectionInfo['Id'], ConnectionId: this.myConnectionInfo['ConnectionId'] });
            if (this.newClickedMenuName.toLocaleLowerCase() == 'group') {
                this.signalrConnectionService.hubConnectionForChatAPI.invoke(ChatInvoke.CREATE_GROUP, this.myConnectionInfo['Id'], JSON.stringify(this.selectedEntityForGroupOrBroadcast), this.chatRoomForm.get('groupName').value?.trim());
            } else if (this.newClickedMenuName.toLocaleLowerCase() == 'broadcast') {
                this.signalrConnectionService.hubConnectionForChatAPI.invoke(ChatInvoke.CREATE_BOARDCAST, this.myConnectionInfo['Id'], JSON.stringify(this.selectedEntityForGroupOrBroadcast), this.chatRoomForm.get('groupName').value?.trim());
            }
            this.resetUserList('isSelected'); // when clicked on Create Group
            this.showUsersList = true;
            this.isNewMenuClicked = false;
            this.filterUserList(this.newClickedMenuName.toLocaleLowerCase());
            this.newClickedMenuName = '';
            this.selectedEntityForGroupOrBroadcast = [];
            this.chatRoomForm.get('groupName').reset('');
        } else {
            console.log("Connection issue on create group/boardcast");
        }
    }

    resetUserList(key) {
        this.userList?.forEach((userData) => {
            userData[key] = false;
        });
    }

    hideAllQuickMenu() {
        this.quickMenu1?.hide();
        this.quickChatMenu1?.hide();
    }

    openQuickMenu(e) {
        this.quickChatMenu1?.hide();
        this.quickMenu1?.toggle(e);
    }

    onClickEntity(entityData) {
        this.hideAllQuickMenu();
        // check below conditions when we have complete requiremenet about all 3 options
        if (!this.isNewMenuClicked || this.newClickedMenuName.toLocaleLowerCase() == 'chat') { // If New Menu Select is not clicked
            this.selectedEntity = entityData;
            this.messages = [];
            this.chatRoomForm.get('sendMessage').enable();
            this.uploadformdata = null;
            this.selectedFiles = [];
            this.showSpinnerOnScroll = true;
            this.callOnScroll = true;
            this.rxjsService.setPopupLoaderProperty(true);
            this.onFetchMsg(entityData);
            this.sendMsg?.nativeElement?.focus();
        } else { // If New Menu Select is clicked
            let selectedUserIndex = this.selectedEntityForGroupOrBroadcast.findIndex(selectedUser => selectedUser['Id'] == entityData['id']);
            if (selectedUserIndex >= 0) {
                this.selectedEntityForGroupOrBroadcast.splice(selectedUserIndex, 1);
                entityData['isSelected'] = false;
            } else {
                this.selectedEntityForGroupOrBroadcast.push({ Id: entityData['id'], ConnectionId: entityData['connectionId'] });
                entityData['isSelected'] = true;
            }
        }
    }

    onFetchMsg(entityData) {
        this.getEntityDetails(this.loggedUser.userId, entityData['id'], entityData['isGroup'], 0, this.maximumChats)
        .subscribe((response: IApplicationResponse) => {
            if (response.isSuccess && response.statusCode === 200) {
                this.messages = response.resources.reverse();
                this.scrollOnSendReceive();
            }
            entityData['messageCount'] = 0;
            this.showSpinnerOnScroll = false;
            this.rxjsService.setPopupLoaderProperty(false);
        });
    }

    clearSelection() {
        this.selectedEntityForGroupOrBroadcast = [];
        this.resetUserList('isSelected');
    }

    selectAllRecipients() {
        this.userList?.forEach((userData, i: number) => {
            if (!userData['isSelected']) {
                userData['isSelected'] = true;
                this.selectedEntityForGroupOrBroadcast.push({ Id: userData['id'], ConnectionId: userData['connectionId'] });
            }
        });
    }

    getEntityDetails(fromUserId, toUserId, isGroup, pageIndex, maximumRows) {
        return this.crudService.get(
            ModulesBasedApiSuffix.COMMON_API,
            ChatRoomModuleApiSuffixModels.GET_ALL_CHATS,
            undefined,
            false,
            prepareGetRequestHttpParams(pageIndex, maximumRows, {
                FromUserId: fromUserId,
                ToUserId: toUserId,
                IsGroup: isGroup
            })
        );
    }

    sendMessage() {
        this.hideAllQuickMenu();
        if (this.uploadformdata && this.enableEntity()) {
            this.uploadFileAPI();
        }
        else if (this.chatRoomForm.get('sendMessage').value != '' && this.enableEntity()) {
            if (this.selectedEntity['isGroup']) {
                if (this.selectedEntity['isBroadCast']) {
                    this.signalrConnectionService.hubConnectionForChatAPI.invoke(ChatInvoke.SEND_TO_BOARDCAST, this.selectedEntity['id'], this.loggedUser.displayName, this.chatRoomForm.get('sendMessage').value);
                } else {
                    this.signalrConnectionService.hubConnectionForChatAPI.invoke(ChatInvoke.SEND_TO_GROUP, this.selectedEntity['id'], this.loggedUser.displayName, this.chatRoomForm.get('sendMessage').value);
                }
            } else {
                let sendMessageTimeStamp = new Date();
                let strTime = sendMessageTimeStamp.toLocaleString("en-US", {
                    timeZone: 'Africa/Cairo'
                });
                const dateTimeUtc = this.momentService.toMoment(strTime).format("h:mm A");
                this.signalrConnectionService.hubConnectionForChatAPI.invoke(ChatInvoke.SEND_MESSAGE, this.selectedEntity['connectionId'], this.selectedEntity['id'], this.selectedEntity['name'], this.loggedUser.displayName, this.chatRoomForm.get('sendMessage').value);
                if (this.myConnectionInfo) {
                    this.messages.push({
                        connectionId: this.myConnectionInfo['ConnectionId'],
                        receiver: this.selectedEntity['name'],
                        sender: this.loggedUser.displayName,
                        text: this.chatRoomForm.get('sendMessage').value,
                        toConnectionId: this.selectedEntity['connectionId'],
                        time: dateTimeUtc, // new Date().toLocaleTimeString().replace(/:\d+ /, ' '),
                        isGroup: false,
                        fromUserId: this.myConnectionInfo['Id'],
                        touserId: this.selectedEntity['id'],
                        fileName: null,
                        isFile: false
                    });
                } else {
                    console.log("Connection issue on send msg");
                }
                this.scrollOnSendReceive();
            }
            this.chatRoomForm.get('sendMessage').setValue('');
        }
    }

    enableEntity() {
        return Object?.keys(this?.selectedEntity)?.length;
    }

    openDocument(file) {
        if (this.enableEntity()) {
            file.click();
        }
    }

    removeSelectedFile(index) {
        // Delete the item from fileNames list
        this.selectedFiles.splice(index, 1);
        // delete file from FileList
        this.uploadformdata = null;
        this.uploadFile.nativeElement.value = null;
        setTimeout(() => {
            this.sendMsg?.nativeElement?.focus();
        }, 500);
    }

    uploadDocument(event) {
        this.hideAllQuickMenu();
        for (var i = 0; i < event.target.files.length; i++) {
            let selectedFile = event.target.files[i];
            const path = selectedFile.name.split('.');
            const extension = path[path.length - 1];
            const fileNameCondition = isValidFilename(selectedFile?.name, { supportedExtensions: this.fileFormats, extension: extension }, { fileSize: selectedFile?.size, allowedSize: this._FileSize })?.errorMsg;
            if (fileNameCondition) {
                return this.snackbarService.openSnackbar(fileNameCondition);
            }
            this.selectedFiles = [];
            this.totalFileSize += selectedFile?.size;
            this.selectedFiles.push(selectedFile);
            let fileUploadData = {
                File: selectedFile,
                Obj: JSON.stringify({
                    FileName: selectedFile['name'],
                    FromUserId: this.loggedUser.userId,
                    ToUserId: this.selectedEntity['id'],
                    FromUserName: this.loggedUser.displayName,
                    ToUserName: this.selectedEntity['name'],
                    IsGroup: this.selectedEntity['isGroup'],
                    IsBroadCast: this.selectedEntity['isBroadCast']
                })
            };
            let formdata = new FormData();
            Object.keys(fileUploadData).forEach((key) => {
                formdata.append(key, fileUploadData[key]);
            });
            this.uploadformdata = formdata;
        }
    }

    uploadFileAPI() {
        this.rxjsService.setPopupLoaderProperty(true);
        this.crudService.fileUpload(
            ModulesBasedApiSuffix.COMMON_API,
            ChatRoomModuleApiSuffixModels.DOUCMENT_UPLOAD,
            this.uploadformdata
        ).subscribe((response: IApplicationResponse) => {
            if (response.isSuccess && response.statusCode === 200) {
                if (!this.selectedEntity['isGroup']) {
                    let sendMessageTimeStamp = new Date();
                    let strTime = sendMessageTimeStamp.toLocaleString("en-US", {
                        timeZone: 'Africa/Cairo'
                    });
                    const dateTimeUtc = this.momentService.toMoment(strTime).format("h:mm A");
                    if (this.myConnectionInfo?.ConnectionId) {
                        this.messages.push({
                            connectionId: this.myConnectionInfo['ConnectionId'],
                            receiver: this.selectedEntity['name'],
                            sender: this.loggedUser.displayName,
                            text: response.resources,
                            toConnectionId: this.selectedEntity['connectionId'],
                            time: dateTimeUtc, // new Date().toLocaleTimeString().replace(/:\d+ /, ' '),
                            isGroup: this.selectedEntity['isGroup'],
                            fromUserId: this.myConnectionInfo['Id'],
                            touserId: this.selectedEntity['id'],
                            fileName: this.selectedFiles[0]['name'],
                            isFile: true
                        });
                    } else {
                        this.onClickEntity(this.selectedEntity);
                    }
                    this.uploadformdata = null;
                    this.selectedFiles = [];
                    this.scrollOnSendReceive();
                }
            }
            this.rxjsService.setPopupLoaderProperty(false);
        });
    }

    ngAfterViewInit() {
        // this.scrollData = this.chatScrollBar?.nativeElement?.getElementsByClassName('ng-native-scrollbar-hider')[0];
        this.scrollData = this.chatScrollBar?.el?.nativeElement?.getElementsByClassName("ui-scrollpanel-content")[0];

    }

    scrollOnSendReceive() {
        setTimeout(() => {
            if (this.scrollData?.scrollHeight) {
                this.chatScrollBar.scrollTop(this.scrollData?.scrollHeight);
            }
            let maximumRows = 0;
            this.scrollData.onscroll = (x) => {
                if (x.target.scrollTop <= 0) {
                    if (this.callOnScroll) {
                        maximumRows = maximumRows + 1;
                        this.showSpinnerOnScroll = true;
                        this.rxjsService.setPopupLoaderProperty(true);
                        this.getEntityDetails(this.loggedUser.userId, this.selectedEntity['id'], this.selectedEntity['isGroup'], maximumRows, this.maximumChats).subscribe((response: IApplicationResponse) => {
                            if (response.isSuccess && response.statusCode === 200) {
                                if (response.resources.length > 0) {
                                    this.messages = response.resources.reverse().concat(this.messages);
                                    setTimeout(() => {
                                        this.chatScrollBar.scrollTop(response.resources.length * 70); //700
                                    }, 0);
                                } else {
                                    this.callOnScroll = false;
                                }
                            }
                            this.showSpinnerOnScroll = false;
                            this.rxjsService.setPopupLoaderProperty(false);
                        });
                    }
                }
            }
        }, 500);
    }

    getChatImage(message) {
        return (this.selectedEntity?.profileImagePath && message?.sender == this.selectedEntity?.name) ? this.selectedEntity?.profileImagePath
            : (message?.receiver == this.loggedUser?.userId && this.loggedUser?.profileImageUrl) ? this.loggedUser?.profileImageUrl : '';
    }

    getChatHeaderImage() {
        return (this.selectedEntity?.name && this.selectedEntity?.profileImagePath) || (!this.selectedEntity && this.loggedUser?.profileImageUrl);
    }

    getSelectedGroup() {
        return this.selectedEntity?.isGroup;
    }

    showArrowButton(message) {
        return message?.fromUserId == this.loggedUser?.userId;
    }

    getSelectedBroadCast() {
        return this.selectedEntity?.isBroadCast;
    }

    getSelectedChat(message) {
        return (this.selectedEntity?.profileImagePath && message?.sender == this.selectedEntity?.name) || (message?.receiver == this.loggedUser?.userId && this.loggedUser?.profileImageUrl);
    }

    onReadReceipt(message) {
        if (!message?.messageId) {
            return;
        }
        this.rxjsService.setPopupLoaderProperty(true);
        this.crudService.get(ModulesBasedApiSuffix.SHARED, ChatRoomModuleApiSuffixModels.CHAT_MESSAGES_RECEIPT_INFO, null, false, prepareRequiredHttpParams({ messageId: message?.messageId, chatGroupId: this.selectedEntity?.id }))
            .subscribe((res: IApplicationResponse) => {
                if (res?.isSuccess && res?.statusCode == 200) {
                    this.readByReceiptList = res?.resources?.filter(el => el.isRead == true);
                    this.unreadByReceiptList = res?.resources?.filter(el => el.isRead == false);
                    this.receiptList = this.readByReceiptList;
                    this.showReceiptInfo = true;
                }
                this.rxjsService.setPopupLoaderProperty(false);
            })
    }

    onReceiptTabClick(e) {
        if (e?.index == 0) {
            this.receiptList = this.readByReceiptList;
        } else if (e?.index == 1) {
            this.receiptList = this.unreadByReceiptList;
        }
    }

    //Get Details
    getonChatFileSizeConfigurationDetailsById(): Observable<IApplicationResponse> {
        return this.crudService.get(
            ModulesBasedApiSuffix.SHARED,
            TechnicalMgntModuleApiSuffixModels.CHAT_FILE_SIZE_CONFIG,
            undefined, null)
    };

    ngOnDestroy() {
        if (this.listSubscription) {
            this.listSubscription?.unsubscribe();
        }
        if (this.chatEventsSubscription) {
            this.chatEventsSubscription?.unsubscribe();
        }
        this.rxjsService.setDialogOpenProperty(false);
        this.messageService.clear();
    }
}